import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'

/**
 * affix: true，TagsView标签常显
 * noCache: true, 页面不缓存
 * name字段与各页面中name字段需一致，KeepAlive才能生效
 */

const routes = [
  {
    path: '/',
    component: () => import('@/views/login'),
    meta: { title: '登陆' },
  },

  //首页
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: 'Home',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', affix: true, noCache: false }
      }
    ]
  },

  //解锁页面
  {
    path: '/lock',
    component: Layout,
    redirect: '/lock/index',
    children: [
      {
        path: 'index',
        name: 'Lock',
        component: () => import('@/views/lock/index'),
        meta: { title: '解锁', noCache: true}
      }
    ]
  },

  //系统管理
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/sys-model',
    children: [
      {
        path: 'sys-model',
        component: () => import('@/views/setting/sys-model'),
        name: 'SysModel',
        meta: { title: '后台目录', noCache: false}
      },
      {
        path: 'sys-admin',
        component: () => import('@/views/setting/sys-admin'),
        name: 'SysAdmin',
        meta: { title: '用户权限', noCache: false}
      },
      {
        path: 'sys-role',
        component: () => import('@/views/setting/sys-role'),
        name: 'SysRole',
        meta: { title: '角色权限', noCache: false}
      },
      {
        path: 'sys-param',
        component: () => import('@/views/setting/sys-param'),
        name: 'SysParam',
        meta: { title: '系统参数', noCache: false}
      },
    ]
  },

  //门店管理
  {
    path: '/shop',
    component: Layout,
    redirect: '/shop/index',
    children: [
      {
        path: 'index',
        name: 'Shop',
        component: () => import('@/views/shop/index'),
        meta: { title: '门店管理', noCache: false}
      },
      {
        path: 'discount',
        name: 'ShopDiscount',
        component: () => import('@/views/shop/discount'),
        meta: { title: '门店折扣', noCache: false}
      },
      {
        path: 'price',
        name: 'ShopPrice',
        component: () => import('@/views/shop/price'),
        meta: { title: '会员价格', noCache: false}
      },
      {
        path: 'bonus',
        name: 'ShopBonus',
        component: () => import('@/views/shop/bonus'),
        meta: { title: '提成设置', noCache: false }
      },
      {
        path: 'config',
        name: 'ShopConfig',
        component: () => import('@/views/shop/config'),
        meta: { title: '门店医疗金配置', noCache: false }
      },
    ]
  },

  //项目管理
  {
    path: '/project',
    component: Layout,
    redirect: '/project/index',
    children: [
      {
        path: 'index',
        name: 'Project',
        component: () => import('@/views/project/index'),
        meta: { title: '项目管理', noCache: false}
      },
      {
        path: 'price',
        name: 'ProjectPrice',
        component: () => import('@/views/project/price'),
        meta: { title: '项目价格', noCache: false}
      }
    ]
  },

  //宠物类别管理
  {
    path: '/pet',
    component: Layout,
    redirect: '/pet/index',
    children: [
      {
        path: 'index',
        name: 'Pet',
        component: () => import('@/views/pet/index'),
        meta: { title: '宠物类别', noCache: false }
      }
    ]
  },

  //客服管理
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user/list'),
        meta: { title: '客户管理', noCache: false }
      },
      {
        path: 'member',
        name: 'UserMember',
        component: () => import('@/views/user/member'),
        meta: { title: '会员管理', noCache: false }
      },
      {
        path: 'pet',
        name: 'UserPet',
        component: () => import('@/views/user/pet'),
        meta: { title: '宠物管理', noCache: false }
      }
    ]
  },

  //预约管理
  {
    path: '/preBook',
    component: Layout,
    redirect: '/preBook/index',
    children: [
      {
        path: 'index',
        name: 'PreBookIndex',
        component: () => import('@/views/preBook/index'),
        meta: { title: '预约管理', noCache: false}
      }
    ]
  },

  //统计管理
  {
    path: '/stat',
    component: Layout,
    redirect: '/stat/payment',
    children: [
      {
        path: 'payment',
        name: 'StatPayment',
        component: () => import('@/views/stat/payment'),
        meta: { title: '支付统计', noCache: false}
      },
      {
        path: 'consume',
        name: 'StatConsume',
        component: () => import('@/views/stat/consume'),
        meta: { title: '消费统计', noCache: false}
      },
      {
        path: 'bonus',
        name: 'StatBonus',
        component: () => import('@/views/stat/bonus'),
        meta: { title: '业绩统计', noCache: false}
      },
      {
        path: 'repurchase',
        name: 'StatRepurchase',
        component: () => import('@/views/stat/repurchase'),
        meta: { title: '复购统计', noCache: false}
      },
      {
        path: 'wallet',
        name: 'StatWallet',
        component: () => import('@/views/stat/wallet'),
        meta: { title: '充值统计', noCache: false}
      }
    ]
  },

  //供货商管理
  {
    path: '/commodity',
    component: Layout,
    redirect: '/commodity/supplier',
    children: [
      {
        path: 'supplier',
        name: 'CommoditySupplier',
        component: () => import('@/views/commodity/supplier'),
        meta: { title: '供应商管理', noCache: false}
      },
      {
        path: 'brand',
        name: 'CommodityBrand',
        component: () => import('@/views/commodity/brand'),
        meta: { title: '品牌管理', noCache: false}
      },
      {
        path: 'index',
        name: 'CommodityIndex',
        component: () => import('@/views/commodity/index'),
        meta: { title: '商品管理', noCache: false}
      },
      {
        path: 'purchase',
        name: 'CommodityPurchase',
        component: () => import('@/views/commodity/purchase'),
        meta: { title: '采购商品', noCache: false}
      }
    ]
  },

  //库存管理
  {
    path: '/stock',
    component: Layout,
    redirect: '/stock/index',
    children: [
      {
        path: 'index',
        name: 'StockIndex',
        component: () => import('@/views/stock/index'),
        meta: { title: '出入库管理', noCache: false}
      },
      {
        path: 'commodity',
        name: 'StockCommodity',
        component: () => import('@/views/stock/commodity'),
        meta: { title: '商品库存', noCache: false}
      },
      {
        path: 'take',
        name: 'StockTake',
        component: () => import('@/views/stock/take'),
        meta: { title: '盘点记录', noCache: false}
      },
      {
        path: 'audit',
        name: 'StockAudit',
        component: () => import('@/views/stock/audit'),
        meta: { title: '盘点审核', noCache: false}
      }
    ]
  },

  //客户回访
  {
    path: '/visit',
    component: Layout,
    redirect: '/visit/index',
    children: [
      {
        path: 'index',
        name: 'VisitIndex',
        component: () => import('@/views/visit/index'),
        meta: { title: '客户回访', noCache: false}
      },
      {
        path: 'evaluation',
        name: 'VisitEvaluation',
        component: () => import('@/views/visit/evaluation'),
        meta: { title: '评价短信', noCache: false}
      }
    ]
  },

  //轮播图管理
  {
    path: '/banner',
    component: Layout,
    redirect: '/banner/index',
    children: [
      {
        path: 'index',
        name: 'BannerIndex',
        component: () => import('@/views/banner/index'),
        meta: { title: '轮播图管理', noCache: false}
      }
    ]
  },

  //卫生打卡
  {
    path: '/hygiene',
    component: Layout,
    redirect: '/hygiene/index',
    children: [
      {
        path: 'index',
        name: 'HygieneIndex',
        component: () => import('@/views/hygiene/index'),
        meta: { title: '卫生打卡', noCache: false}
      },
      {
        path: 'shop',
        name: 'HygieneShop',
        component: () => import('@/views/hygiene/shop'),
        meta: { title: '门店配置', noCache: false}
      },
      {
        path: 'standard',
        name: 'HygieneStandard',
        component: () => import('@/views/hygiene/standard'),
        meta: { title: '卫生标准', noCache: false}
      }
    ]
  },

  //邀请好友
  {
    path: '/prize',
    component: Layout,
    redirect: '/invite/prize',
    children: [
      {
        path: 'prize',
        name: 'InvitePrize',
        component: () => import('@/views/invite/prize'),
        meta: { title: '邀请奖励', noCache: false}
      },
      {
        path: 'user',
        name: 'InviteUser',
        component: () => import('@/views/invite/user'),
        meta: { title: '用户邀请', noCache: false}
      }
    ]
  },

  //好评返现
  {
    path: '/cashback',
    component: Layout,
    redirect: '/cashback/index',
    children: [
      {
        path: 'index',
        name: 'CashbackIndex',
        component: () => import('@/views/cashback/index'),
        meta: { title: '好评返现', noCache: false}
      }
    ]
  },

  //医疗保障
  {
    path: '/medical',
    component: Layout,
    redirect: '/medical/security-case',
    children: [
      {
        path: 'security-case',
        name: 'MedicalSecurityCase',
        component: () => import('@/views/medical/security-case'),
        meta: { title: '保障案例', noCache: false}
      },
      {
        path: 'adopt-case',
        name: 'MedicalAdoptCase',
        component: () => import('@/views/medical/adopt-case'),
        meta: { title: '领养案例', noCache: false}
      },
      {
        path: 'security',
        name: 'MedicalSecurity',
        component: () => import('@/views/medical/security'),
        meta: { title: '用户保障单', noCache: false}
      },
      {
        path: 'invite',
        name: 'MedicalInvite',
        component: () => import('@/views/medical/invite'),
        meta: { title: '邀请记录', noCache: false}
      }
    ]
  },

  //渠道管理
  {
    path: '/channel',
    component: Layout,
    redirect: '/channel/index',
    children: [
      {
        path: 'index',
        name: 'ChannelIndex',
        component: () => import('@/views/channel/index'),
        meta: { title: '渠道管理', noCache: false}
      },
      {
        path: 'user',
        name: 'ChannelUser',
        component: () => import('@/views/channel/user'),
        meta: { title: '渠道用户管理', noCache: false}
      }
    ]
  },


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const nextRoute = JSON.parse(sessionStorage.getItem('navArray'));
  // console.log(nextRoute)
  if(to.path != '/home/index' && to.path != '/' && to.path != '/lock/index') {
    if (nextRoute == null || nextRoute.indexOf(to.path) == -1) {
      next({path: '/'})
    }
  }
  next()
})

export default router
